module.exports = __webpack_public_path__ + "img/AWS.f0b39fe2.png";